import React from "react";
import PropTypes from "prop-types";
import "../Main.css";

export default class PaymentResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentSuccess: false,
      crmNumber: "", // updated
      error: "",
      color: "red",
      processing: false,
    };
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const status = query.get("status");
    const mid = query.get("MID");

    fetch(`${process.env.REACT_APP_API_URL}/api/submit/SubmitPayment`, {
      method: "POST",
      body: JSON.stringify({
        STAT: status,
        MID: mid,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200 && res.Status === "success") {
          const crmNumber = mid || res.CRMNumber || "";
          this.setState({
            paymentSuccess: true,
            crmNumber,
          });
          sessionStorage.clear();
        } else {
          this.setState({
            error:
              res.Msg ||
              "Your payment has failed. Please log in again to complete your payment.",
            paymentSuccess: false,
          });
          sessionStorage.clear();
        }
      })
      .catch((err) => {
        this.setState({
          error: "Something went wrong while processing your payment.",
          processing: false,
        });
        console.error(err);
      });
  }

  render() {
    const { error, color, paymentSuccess, crmNumber } = this.state;

    return (
      <div style={styles.page}>
        <div style={styles.card}>
          {paymentSuccess ? (
            <>
              <h2 style={styles.title}>Payment Successful</h2>
              <p style={styles.text}>
                Your application has been submitted successfully.
              </p>
              <p style={styles.textBold}>
                Use this as your payment number at any BoB POS:
              </p>
              <p style={styles.paymentNumber}>{crmNumber}</p>
              <p style={styles.note}>
                Please keep this number for your records. You will need it to
                complete your payment at any Bank of Beirut POS.
              </p>
            </>
          ) : (
            <>
              <h2 style={styles.titleFailed}>Payment Failed</h2>
              <p style={{ color }}>{error}</p>
              <a href="/ApplicationForm/login" style={styles.retryLink}>
                Return to Login
              </a>
            </>
          )}
        </div>
      </div>
    );
  }
}

PaymentResult.propTypes = {
  history: PropTypes.object,
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f4f6f8",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    padding: "40px 30px",
    maxWidth: "480px",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007B5E",
    marginBottom: "15px",
  },
  titleFailed: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#c0392b",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#333",
    marginBottom: "10px",
  },
  textBold: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#444",
    marginTop: "15px",
  },
  paymentNumber: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#D35400",
    margin: "12px 0 18px 0",
  },
  note: {
    fontSize: "14px",
    color: "#666",
  },
  retryLink: {
    display: "inline-block",
    marginTop: "20px",
    textDecoration: "none",
    color: "#007B5E",
    fontWeight: "bold",
  },
};
